/**
 * Image Compression Utility
 * Compresses images to WebP format with configurable quality and dimensions
 */

export const compressImage = (file, options = {}) => {
    const {
        maxWidth = 1920,
        maxHeight = 1920,
        quality = 0.85,
        format = 'image/webp'
    } = options;

    return new Promise((resolve, reject) => {
        // Validate file type
        if (!file.type.startsWith('image/')) {
            reject(new Error('الملف المحدد ليس صورة / Selected file is not an image'));
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                let width = img.width;
                let height = img.height;

                // Calculate new dimensions while maintaining aspect ratio
                if (width > height) {
                    if (width > maxWidth) {
                        height = height * (maxWidth / width);
                        width = maxWidth;
                    }
                } else {
                    if (height > maxHeight) {
                        width = width * (maxHeight / height);
                        height = maxHeight;
                    }
                }

                canvas.width = width;
                canvas.height = height;

                // Draw image on canvas
                ctx.drawImage(img, 0, 0, width, height);

                // Convert to WebP with compression
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            // Create new File object with compressed image
                            const compressedFile = new File(
                                [blob],
                                file.name.replace(/\.[^/.]+$/, ".webp"),
                                { type: format }
                            );
                            
                            // Log compression results
                            // const originalSize = (file.size / 1024).toFixed(2);
                            // const compressedSize = (blob.size / 1024).toFixed(2);
                            // const savings = (((file.size - blob.size) / file.size) * 100).toFixed(1);
                            
                            // console.log(`✅ Image compressed: ${originalSize}KB → ${compressedSize}KB (${savings}% reduction)`);
                            
                            resolve(compressedFile);
                        } else {
                            reject(new Error('فشل ضغط الصورة / Image compression failed'));
                        }
                    },
                    format,
                    quality
                );
            };

            img.onerror = () => reject(new Error('فشل تحميل الصورة / Failed to load image'));
        };

        reader.onerror = () => reject(new Error('فشل قراءة الملف / Failed to read file'));
    });
};

/**
 * Compress multiple images
 */
export const compressImages = async (files, options = {}) => {
    const compressedFiles = [];
    const errors = [];

    for (const file of files) {
        try {
            const compressed = await compressImage(file, options);
            compressedFiles.push(compressed);
        } catch (err) {
            console.error('Error compressing image:', err);
            errors.push({ file: file.name, error: err.message });
        }
    }

    return { compressedFiles, errors };
};